import {
  Tenant,
  Company,
  Person,
  Event,
  EventAttendee,
  FeedPost,
  Message,
  Conversation,
  Challenge,
  Badge,
} from '../types'

export const tenants: Tenant[] = [
  {
    id: 't1',
    name: 'FC Bayern München',
    slug: 'fc-bayern',
    logo: '⚽',
    sport: 'Fußball',
    league: 'Bundesliga',
    primaryColor: '#DC052D',
    secondaryColor: '#0066B2',
    memberCount: 342,
    companyCount: 89,
    eventCount: 24,
    status: 'active',
    createdAt: '2023-01-15',
  },
  {
    id: 't2',
    name: 'Borussia Dortmund',
    slug: 'bvb',
    logo: '⚽',
    sport: 'Fußball',
    league: 'Bundesliga',
    primaryColor: '#FDE100',
    secondaryColor: '#000000',
    memberCount: 287,
    companyCount: 76,
    eventCount: 18,
    status: 'active',
    createdAt: '2023-02-20',
  },
  {
    id: 't3',
    name: 'RB Leipzig',
    slug: 'rb-leipzig',
    logo: '⚽',
    sport: 'Fußball',
    league: 'Bundesliga',
    primaryColor: '#DD0741',
    secondaryColor: '#001F47',
    memberCount: 198,
    companyCount: 54,
    eventCount: 15,
    status: 'active',
    createdAt: '2023-03-10',
  },
  {
    id: 't4',
    name: 'Eintracht Frankfurt',
    slug: 'eintracht',
    logo: '🦅',
    sport: 'Fußball',
    league: 'Bundesliga',
    primaryColor: '#E1000F',
    secondaryColor: '#000000',
    memberCount: 231,
    companyCount: 67,
    eventCount: 20,
    status: 'active',
    createdAt: '2023-04-05',
  },
  {
    id: 't5',
    name: 'VfB Stuttgart',
    slug: 'vfb',
    logo: '⚽',
    sport: 'Fußball',
    league: 'Bundesliga',
    primaryColor: '#E32219',
    secondaryColor: '#FFFFFF',
    memberCount: 176,
    companyCount: 48,
    eventCount: 12,
    status: 'active',
    createdAt: '2023-05-12',
  },
  {
    id: 't6',
    name: 'SC Freiburg',
    slug: 'sc-freiburg',
    logo: '🦊',
    sport: 'Fußball',
    league: 'Bundesliga',
    primaryColor: '#000000',
    secondaryColor: '#E2001A',
    memberCount: 124,
    companyCount: 35,
    eventCount: 10,
    status: 'active',
    createdAt: '2023-06-18',
  },
]

const baseCompanies: Company[] = [
  {
    id: 'c1',
    tenantId: 't1',
    name: 'Müller Automotive GmbH',
    description:
      'Führender Zulieferer für die Automobilindustrie mit Fokus auf E-Mobilität.',
    industry: 'Automotive',
    services: ['E-Mobilität', 'Fertigung', 'R&D'],
    logo: '🚗',
    website: 'www.mueller-auto.de',
    employeeCount: 450,
    memberSince: '2023-02-01',
  },
  {
    id: 'c2',
    tenantId: 't1',
    name: 'Alpenbank AG',
    description:
      'Ihre vertrauensvolle Bank für den Mittelstand und Privatkunden in Bayern.',
    industry: 'Finanzdienstleistungen',
    services: ['Corporate Banking', 'Vermögensverwaltung'],
    logo: '🏦',
    website: 'www.alpenbank.de',
    employeeCount: 1200,
    memberSince: '2023-01-20',
  },
  {
    id: 'c3',
    tenantId: 't1',
    name: 'TechVision Solutions',
    description:
      'Innovative Softwarelösungen und IT-Consulting für den Mittelstand.',
    industry: 'IT & Software',
    services: ['Cloud Migration', 'Custom Software', 'IT Security'],
    logo: '💻',
    website: 'www.techvision.de',
    employeeCount: 85,
    memberSince: '2023-03-15',
  },
  {
    id: 'c4',
    tenantId: 't1',
    name: 'Bayerische Immobilien Gruppe',
    description:
      'Projektentwicklung und Immobilienmanagement im süddeutschen Raum.',
    industry: 'Immobilien',
    services: ['Projektentwicklung', 'Facility Management'],
    logo: '🏢',
    website: 'www.bay-immo.de',
    employeeCount: 320,
    memberSince: '2023-04-10',
  },
  {
    id: 'c5',
    tenantId: 't1',
    name: 'Gastro Concept München',
    description:
      'Premium Catering und Event-Gastronomie für Großveranstaltungen.',
    industry: 'Gastronomie',
    services: ['Event Catering', 'VIP Hospitality'],
    logo: '🍽️',
    website: 'www.gastro-concept.de',
    employeeCount: 150,
    memberSince: '2023-01-25',
  },
  {
    id: 'c6',
    tenantId: 't1',
    name: 'Meridian Consulting',
    description: 'Strategieberatung mit Fokus auf digitale Transformation.',
    industry: 'Unternehmensberatung',
    services: ['Strategie', 'Change Management'],
    logo: '📈',
    website: 'www.meridian-consult.de',
    employeeCount: 60,
    memberSince: '2023-05-05',
  },
  {
    id: 'c7',
    tenantId: 't1',
    name: 'SüdMedia Verlag',
    description: 'Eines der größten Medienhäuser im Süden Deutschlands.',
    industry: 'Medien & Kommunikation',
    services: ['Print', 'Digital Media', 'PR'],
    logo: '📰',
    website: 'www.suedmedia.de',
    employeeCount: 200,
    memberSince: '2023-02-28',
  },
  {
    id: 'c8',
    tenantId: 't1',
    name: 'Kraft & Partner Rechtsanwälte',
    description:
      'Wirtschaftskanzlei spezialisiert auf Vertrags- und Sportrecht.',
    industry: 'Recht',
    services: ['Sportrecht', 'Corporate Law'],
    logo: '⚖️',
    website: 'www.kraft-partner.de',
    employeeCount: 45,
    memberSince: '2023-06-12',
  },
  {
    id: 'c9',
    tenantId: 't1',
    name: 'AlpinTech Engineering',
    description: 'Spezialmaschinenbau und Automatisierungstechnik.',
    industry: 'Maschinenbau',
    services: ['Automatisierung', 'Robotik'],
    logo: '⚙️',
    website: 'www.alpintech.de',
    employeeCount: 380,
    memberSince: '2023-07-01',
  },
  {
    id: 'c10',
    tenantId: 't1',
    name: 'Bavaria Insurance Group',
    description: 'Versicherungslösungen für Unternehmen und Großkunden.',
    industry: 'Versicherungen',
    services: ['Gewerbeversicherungen', 'Risk Management'],
    logo: '🛡️',
    website: 'www.bavaria-insurance.de',
    employeeCount: 900,
    memberSince: '2023-01-18',
  },
]

// Generate more companies to hit the 25+ requirement
export const companies: Company[] = [
  ...baseCompanies,
  ...Array.from({ length: 18 }).map((_, i) => ({
    id: `c${i + 11}`,
    tenantId: 't1',
    name: `Partner Unternehmen ${i + 1}`,
    description: 'Ein verlässlicher Partner im Netzwerk des FC Bayern München.',
    industry: ['Marketing', 'Logistik', 'Handel', 'Gesundheit', 'Energie'][
      i % 5
    ],
    services: ['B2B Services', 'Consulting'],
    logo: ['📦', '🏥', '⚡', '🛒', '🎯'][i % 5],
    website: `www.partner-${i + 1}.de`,
    employeeCount: Math.floor(Math.random() * 500) + 20,
    memberSince: '2023-08-01',
  })),
]

const basePeople: Person[] = [
  {
    id: 'p1',
    tenantId: 't1',
    companyId: 'c1',
    companyName: 'Müller Automotive GmbH',
    firstName: 'Thomas',
    lastName: 'Müller',
    role: 'Geschäftsführer',
    email: 't.mueller@mueller-auto.de',
    avatar: 'TM',
    interests: ['Automotive', 'Innovation', 'Sport-Sponsoring'],
    bio: 'Leidenschaftlicher Unternehmer und Bayern-Fan seit Kindheitstagen. Suche Austausch zu E-Mobilität.',
    joinedAt: '2023-02-05',
    isOnline: true,
    eventsAttended: 12,
    connectionsCount: 45,
  },
  {
    id: 'p2',
    tenantId: 't1',
    companyId: 'c2',
    companyName: 'Alpenbank AG',
    firstName: 'Sandra',
    lastName: 'Berger',
    role: 'Head of Corporate Banking',
    email: 's.berger@alpenbank.de',
    avatar: 'SB',
    interests: ['Finanzen', 'Netzwerken', 'Digitalisierung'],
    bio: 'Verantwortlich für das Firmenkundengeschäft. Immer auf der Suche nach spannenden neuen Geschäftsmodellen.',
    joinedAt: '2023-01-22',
    isOnline: false,
    eventsAttended: 8,
    connectionsCount: 89,
  },
  {
    id: 'p3',
    tenantId: 't1',
    companyId: 'c3',
    companyName: 'TechVision Solutions',
    firstName: 'Michael',
    lastName: 'Hoffmann',
    role: 'CTO',
    email: 'm.hoffmann@techvision.de',
    avatar: 'MH',
    interests: ['KI', 'Software', 'Startups'],
    bio: 'Tech-Enthusiast. Wir helfen dem Mittelstand bei der digitalen Transformation.',
    joinedAt: '2023-03-16',
    isOnline: true,
    eventsAttended: 5,
    connectionsCount: 34,
  },
  {
    id: 'p4',
    tenantId: 't1',
    companyId: 'c4',
    companyName: 'Bayerische Immobilien Gruppe',
    firstName: 'Julia',
    lastName: 'Weber',
    role: 'Leitung Projektentwicklung',
    email: 'j.weber@bay-immo.de',
    avatar: 'JW',
    interests: ['Immobilien', 'Nachhaltigkeit', 'Architektur'],
    bio: 'Fokus auf nachhaltige Quartiersentwicklung in München und Umgebung.',
    joinedAt: '2023-04-12',
    isOnline: true,
    eventsAttended: 15,
    connectionsCount: 112,
  },
  {
    id: 'p5',
    tenantId: 't1',
    companyId: 'c5',
    companyName: 'Gastro Concept München',
    firstName: 'Andreas',
    lastName: 'Schmidt',
    role: 'Vertriebsleiter',
    email: 'a.schmidt@gastro-concept.de',
    avatar: 'AS',
    interests: ['Gastronomie', 'Events', 'Vertrieb'],
    bio: 'Ihr Ansprechpartner für unvergessliche VIP-Events und Catering.',
    joinedAt: '2023-01-28',
    isOnline: false,
    eventsAttended: 22,
    connectionsCount: 156,
  },
]

const firstNames = [
  'Lukas',
  'Anna',
  'Felix',
  'Laura',
  'Maximilian',
  'Sarah',
  'Leon',
  'Lisa',
  'Tim',
  'Marie',
  'Jan',
  'Sophie',
  'Paul',
  'Lena',
  'Jonas',
]
const lastNames = [
  'Wagner',
  'Becker',
  'Schulz',
  'Hoffmann',
  'Schäfer',
  'Koch',
  'Bauer',
  'Richter',
  'Klein',
  'Wolf',
  'Schröder',
  'Neumann',
  'Schwarz',
  'Zimmermann',
  'Braun',
]
const roles = [
  'CMO',
  'CEO',
  'Head of Sales',
  'Marketing Director',
  'Key Account Manager',
  'CFO',
  'Projektleiter',
  'HR Director',
]

// Generate 45 more people to hit the 50+ requirement
export const people: Person[] = [
  ...basePeople,
  ...Array.from({ length: 47 }).map((_, i) => {
    const fn = firstNames[i % firstNames.length]
    const ln = lastNames[(i * 3) % lastNames.length]
    const comp = companies[(i * 7) % companies.length]
    return {
      id: `p${i + 6}`,
      tenantId: 't1',
      companyId: comp.id,
      companyName: comp.name,
      firstName: fn,
      lastName: ln,
      role: roles[i % roles.length],
      email: `${fn.charAt(0).toLowerCase()}.${ln.toLowerCase()}@${comp.website.replace('www.', '')}`,
      avatar: `${fn.charAt(0)}${ln.charAt(0)}`,
      interests: [
        'Digitalisierung',
        'Nachhaltigkeit',
        'Vertrieb',
        'Marketing',
        'Sport-Sponsoring',
      ]
        .sort(() => 0.5 - Math.random())
        .slice(0, 3),
      bio: `Experte im Bereich ${comp.industry}. Freue mich auf spannende Kontakte im Netzwerk.`,
      joinedAt: '2023-09-01',
      isOnline: Math.random() > 0.7,
      eventsAttended: Math.floor(Math.random() * 10),
      connectionsCount: Math.floor(Math.random() * 100) + 10,
    }
  }),
]

export const events: Event[] = [
  {
    id: 'e1',
    tenantId: 't1',
    title: 'FC Bayern vs. Borussia Dortmund',
    type: 'homeGame',
    date: '2026-04-04',
    time: '18:30',
    location: 'Allianz Arena, München',
    description:
      'Der Klassiker! Erleben Sie das Topspiel in unserer exklusiven Business Lounge. Perfekt zum Netzwerken in emotionaler Atmosphäre.',
    attendeeCount: 285,
    maxAttendees: 300,
    status: 'upcoming',
    imageEmoji: '🏟️',
  },
  {
    id: 'e2',
    tenantId: 't1',
    title: 'Business Lunch: Digitale Transformation',
    type: 'business',
    date: '2026-03-25',
    time: '12:00',
    location: 'Säbener Straße, München',
    description:
      'Spannende Keynotes zur Digitalisierung im Mittelstand. Inklusive Networking-Lunch.',
    attendeeCount: 42,
    maxAttendees: 60,
    status: 'upcoming',
    imageEmoji: '💼',
  },
  {
    id: 'e3',
    tenantId: 't1',
    title: 'Netzwerk-Abend: Nachhaltigkeit im Sport',
    type: 'networking',
    date: '2026-03-19',
    time: '19:00',
    location: 'FC Bayern Museum',
    description:
      'Wie Vereine und Unternehmen gemeinsam nachhaltiger werden können. Offener Austausch.',
    attendeeCount: 56,
    maxAttendees: 80,
    status: 'live',
    imageEmoji: '🌱',
  },
  {
    id: 'e4',
    tenantId: 't1',
    title: 'FC Bayern vs. RB Leipzig',
    type: 'homeGame',
    date: '2026-03-14',
    time: '15:30',
    location: 'Allianz Arena, München',
    description:
      'Spitzenspiel am Samstagnachmittag. Treffen Sie andere Sponsoren in der VIP-Area.',
    attendeeCount: 290,
    maxAttendees: 300,
    status: 'past',
    imageEmoji: '🏟️',
  },
  {
    id: 'e5',
    tenantId: 't1',
    title: 'VIP Dinner mit Vorstand',
    type: 'vip',
    date: '2026-04-15',
    time: '19:30',
    location: 'Käfer Schänke, München',
    description:
      'Exklusives Dinner im kleinen Kreis mit dem Vorstand des FC Bayern.',
    attendeeCount: 20,
    maxAttendees: 25,
    status: 'upcoming',
    imageEmoji: '🍽️',
  },
  {
    id: 'e6',
    tenantId: 't1',
    title: 'Partner Summit 2026',
    type: 'business',
    date: '2026-05-10',
    time: '09:00',
    location: 'Allianz Arena Business Club',
    description:
      'Das große jährliche Treffen aller Partner und Sponsoren. Strategie-Updates und Deep Dives.',
    attendeeCount: 150,
    maxAttendees: 200,
    status: 'upcoming',
    imageEmoji: '🤝',
  },
  {
    id: 'e7',
    tenantId: 't1',
    title: 'Exklusive Stadionführung',
    type: 'vip',
    date: '2026-03-28',
    time: '10:00',
    location: 'Allianz Arena, München',
    description: 'Blick hinter die Kulissen für neue Netzwerk-Mitglieder.',
    attendeeCount: 15,
    maxAttendees: 30,
    status: 'upcoming',
    imageEmoji: '👀',
  },
  {
    id: 'e8',
    tenantId: 't1',
    title: 'Branchentreff Automotive',
    type: 'networking',
    date: '2026-04-20',
    time: '18:00',
    location: 'Audi Dome',
    description:
      'Spezifisches Networking für alle Partner aus dem Automotive-Sektor.',
    attendeeCount: 35,
    maxAttendees: 50,
    status: 'upcoming',
    imageEmoji: '🚗',
  },
  {
    id: 'e9',
    tenantId: 't1',
    title: 'FC Bayern vs. Eintracht Frankfurt',
    type: 'homeGame',
    date: '2026-02-28',
    time: '15:30',
    location: 'Allianz Arena, München',
    description: 'Heimspiel mit Fokus auf regionale Partner.',
    attendeeCount: 275,
    maxAttendees: 300,
    status: 'past',
    imageEmoji: '🏟️',
  },
  {
    id: 'e10',
    tenantId: 't1',
    title: 'FC Bayern vs. VfB Stuttgart',
    type: 'homeGame',
    date: '2026-02-14',
    time: '18:30',
    location: 'Allianz Arena, München',
    description: 'Süd-Derby unter Flutlicht.',
    attendeeCount: 295,
    maxAttendees: 300,
    status: 'past',
    imageEmoji: '🏟️',
  },
  {
    id: 'e11',
    tenantId: 't1',
    title: 'Neujahrsempfang 2026',
    type: 'business',
    date: '2026-01-15',
    time: '18:00',
    location: 'Allianz Arena Business Club',
    description: 'Kick-off ins neue Jahr mit allen Partnern.',
    attendeeCount: 180,
    maxAttendees: 200,
    status: 'past',
    imageEmoji: '🥂',
  },
  {
    id: 'e12',
    tenantId: 't1',
    title: 'FC Bayern vs. SC Freiburg',
    type: 'homeGame',
    date: '2026-01-31',
    time: '15:30',
    location: 'Allianz Arena, München',
    description: 'Erstes Heimspiel der Rückrunde.',
    attendeeCount: 260,
    maxAttendees: 300,
    status: 'past',
    imageEmoji: '🏟️',
  },
]

// Generate attendees for the LIVE event (e3)
export const eventAttendees: EventAttendee[] = people
  .slice(0, 35)
  .map((p, i) => ({
    id: `ea${i}`,
    eventId: 'e3',
    personId: p.id,
    checkedIn: i < 25, // First 25 are checked in
    checkInTime:
      i < 25
        ? `18:${Math.floor(Math.random() * 45)
            .toString()
            .padStart(2, '0')}`
        : undefined,
  }))

const basePosts: FeedPost[] = [
  {
    id: 'fp1',
    tenantId: 't1',
    authorId: 'p1',
    authorName: 'Thomas Müller',
    authorRole: 'Geschäftsführer',
    authorCompany: 'Müller Automotive GmbH',
    authorAvatar: 'TM',
    content:
      'Großartiger Abend beim Business Lunch gestern! Spannende Gespräche über KI im Mittelstand. 🤝 Freue mich auf den weiteren Austausch mit @Michael Hoffmann.',
    type: 'post',
    likes: 24,
    comments: 5,
    createdAt: 'Vor 2 Stunden',
    isSponsored: false,
  },
  {
    id: 'fp2',
    tenantId: 't1',
    authorId: 'admin',
    authorName: 'FC Bayern Business',
    authorRole: 'Club Administration',
    authorCompany: 'FC Bayern München',
    authorAvatar: '⚽',
    content:
      'Willkommen im Netzwerk: 12 neue Unternehmen im Januar! Wir freuen uns, das Partner-Ökosystem weiter auszubauen. Schaut im Verzeichnis vorbei und vernetzt euch.',
    imageEmoji: '📈',
    type: 'news',
    likes: 89,
    comments: 12,
    createdAt: 'Vor 5 Stunden',
    isSponsored: false,
  },
  {
    id: 'fp3',
    tenantId: 't1',
    authorId: 'p2',
    authorName: 'Sandra Berger',
    authorRole: 'Head of Corporate Banking',
    authorCompany: 'Alpenbank AG',
    authorAvatar: 'SB',
    content:
      'Alpenbank AG: Exklusive Konditionen für Netzwerk-Mitglieder. Jetzt Beratungstermin vereinbaren und von unserem Sport-Partner-Programm profitieren! 💼',
    type: 'sponsored',
    likes: 15,
    comments: 2,
    createdAt: 'Gestern',
    isSponsored: true,
  },
  {
    id: 'fp4',
    tenantId: 't1',
    authorId: 'p4',
    authorName: 'Julia Weber',
    authorRole: 'Leitung Projektentwicklung',
    authorCompany: 'Bayerische Immobilien Gruppe',
    authorAvatar: 'JW',
    content:
      'Suchen Partner im Bereich nachhaltige Verpackungen für unser neues Gastro-Konzept im Stadion-Umfeld. Wer hat Kontakte oder Empfehlungen?',
    type: 'post',
    likes: 18,
    comments: 8,
    createdAt: 'Gestern',
    isSponsored: false,
  },
  {
    id: 'fp5',
    tenantId: 't1',
    authorId: 'p5',
    authorName: 'Andreas Schmidt',
    authorRole: 'Vertriebsleiter',
    authorCompany: 'Gastro Concept München',
    authorAvatar: 'AS',
    content:
      'Tolles Heimspiel gestern! Die Atmosphäre in der Arena war unbeschreiblich. ⚽🔥 Danke an alle Partner für die guten Gespräche in der Lounge.',
    imageEmoji: '🏟️',
    type: 'post',
    likes: 56,
    comments: 4,
    createdAt: 'Vor 2 Tagen',
    isSponsored: false,
  },
  {
    id: 'fp6',
    tenantId: 't1',
    authorId: 'admin',
    authorName: 'FC Bayern Business',
    authorRole: 'Club Administration',
    authorCompany: 'FC Bayern München',
    authorAvatar: '⚽',
    content:
      'Save the Date: Partner Summit 2026 am 10. Mai. Die offiziellen Einladungen folgen nächste Woche. Wir haben ein großartiges Programm für euch vorbereitet!',
    type: 'news',
    likes: 112,
    comments: 23,
    createdAt: 'Vor 3 Tagen',
    isSponsored: false,
  },
]

// Generate more posts
export const feedPosts: FeedPost[] = [
  ...basePosts,
  ...Array.from({ length: 25 }).map((_, i) => {
    const p = people[(i * 5) % people.length]
    return {
      id: `fp${i + 7}`,
      tenantId: 't1',
      authorId: p.id,
      authorName: `${p.firstName} ${p.lastName}`,
      authorRole: p.role,
      authorCompany: p.companyName,
      authorAvatar: p.avatar,
      content: [
        'Freue mich auf das nächste Heimspiel! Wer ist noch in der Business Lounge?',
        'Spannender Austausch heute zum Thema Digitalisierung.',
        'Wir erweitern unser Team und suchen Verstärkung im Vertrieb.',
        'Danke für das tolle Networking-Event gestern Abend!',
        'Hat jemand Empfehlungen für gute CRM-Systeme im B2B-Bereich?',
      ][i % 5],
      type: 'post',
      likes: Math.floor(Math.random() * 40) + 1,
      comments: Math.floor(Math.random() * 10),
      createdAt: `Vor ${i + 4} Tagen`,
      isSponsored: false,
    }
  }),
]

export const challenges: Challenge[] = [
  {
    id: 'ch1',
    tenantId: 't1',
    title: 'Erstes Event besucht',
    description: 'Nimm an deinem ersten Connectra-Event teil.',
    type: 'event',
    icon: '🎫',
    target: 1,
    current: 1,
    reward: 'Rookie Badge',
    completed: true,
    badgeEmoji: '🥉',
  },
  {
    id: 'ch2',
    tenantId: 't1',
    title: '3 Heimspiele besucht',
    description: 'Unterstütze das Team bei 3 Heimspielen in einer Saison.',
    type: 'event',
    icon: '🏟️',
    target: 3,
    current: 2,
    reward: 'Stammgast Badge',
    completed: false,
    badgeEmoji: '🥈',
  },
  {
    id: 'ch3',
    tenantId: 't1',
    title: '5 Events in einer Saison',
    description: 'Besuche 5 beliebige Events im Netzwerk.',
    type: 'event',
    icon: '⭐',
    target: 5,
    current: 3,
    reward: 'Networker Badge',
    completed: false,
    badgeEmoji: '🥇',
  },
  {
    id: 'ch4',
    tenantId: 't1',
    title: 'Erster Beitrag gepostet',
    description: 'Teile deine Gedanken im Feed.',
    type: 'social',
    icon: '✍️',
    target: 1,
    current: 1,
    reward: 'Voice Badge',
    completed: true,
    badgeEmoji: '🎤',
  },
  {
    id: 'ch5',
    tenantId: 't1',
    title: '5 Kontakte geknüpft',
    description: 'Verbinde dich mit 5 anderen Mitgliedern.',
    type: 'social',
    icon: '🤝',
    target: 5,
    current: 5,
    reward: 'Connector Badge',
    completed: true,
    badgeEmoji: '🔗',
  },
  {
    id: 'ch6',
    tenantId: 't1',
    title: '10 Likes erhalten',
    description: 'Erhalte 10 Likes auf deine Beiträge.',
    type: 'social',
    icon: '❤️',
    target: 10,
    current: 4,
    reward: 'Influencer Badge',
    completed: false,
    badgeEmoji: '🌟',
  },
  {
    id: 'ch7',
    tenantId: 't1',
    title: 'Erste Nachricht gesendet',
    description: 'Starte eine Konversation mit einem anderen Mitglied.',
    type: 'social',
    icon: '💬',
    target: 1,
    current: 1,
    reward: 'Icebreaker Badge',
    completed: true,
    badgeEmoji: '🧊',
  },
  {
    id: 'ch8',
    tenantId: 't1',
    title: 'Foto mit Maskottchen',
    description: 'Poste ein Foto mit Berni im Feed.',
    type: 'stadium',
    icon: '📸',
    target: 1,
    current: 0,
    reward: 'Fan Badge',
    completed: false,
    badgeEmoji: '🐻',
  },
  {
    id: 'ch9',
    tenantId: 't1',
    title: 'Stadionerlebnis geteilt',
    description: 'Poste ein Bild aus dem Stadion mit dem Emoji 🏟️.',
    type: 'stadium',
    icon: '📱',
    target: 1,
    current: 1,
    reward: 'Reporter Badge',
    completed: true,
    badgeEmoji: '📰',
  },
  {
    id: 'ch10',
    tenantId: 't1',
    title: 'VIP-Bereich besucht',
    description: 'Checke bei einem VIP-Event ein.',
    type: 'stadium',
    icon: '🌟',
    target: 1,
    current: 0,
    reward: 'VIP Badge',
    completed: false,
    badgeEmoji: '👑',
  },
  {
    id: 'ch11',
    tenantId: 't1',
    title: 'Profil vervollständigt',
    description: 'Fülle alle Felder in deinem Profil aus.',
    type: 'social',
    icon: '👤',
    target: 1,
    current: 1,
    reward: 'All-Star Badge',
    completed: true,
    badgeEmoji: '⭐',
  },
  {
    id: 'ch12',
    tenantId: 't1',
    title: '10 Heimspiele besucht',
    description: 'Werde zur Legende auf der Tribüne.',
    type: 'event',
    icon: '🔥',
    target: 10,
    current: 2,
    reward: 'Legend Badge',
    completed: false,
    badgeEmoji: '🏆',
  },
  {
    id: 'ch13',
    tenantId: 't1',
    title: 'Branchen-Experte',
    description: 'Vernetze dich mit 10 Personen aus deiner Branche.',
    type: 'social',
    icon: '💼',
    target: 10,
    current: 3,
    reward: 'Expert Badge',
    completed: false,
    badgeEmoji: '🧠',
  },
  {
    id: 'ch14',
    tenantId: 't1',
    title: 'Frühaufsteher',
    description: 'Checke als einer der Ersten bei einem Event ein.',
    type: 'event',
    icon: '⏰',
    target: 1,
    current: 0,
    reward: 'Early Bird Badge',
    completed: false,
    badgeEmoji: '🦅',
  },
  {
    id: 'ch15',
    tenantId: 't1',
    title: '5 Kommentare geschrieben',
    description: 'Beteilige dich aktiv an Diskussionen im Feed.',
    type: 'social',
    icon: '📝',
    target: 5,
    current: 2,
    reward: 'Discussant Badge',
    completed: false,
    badgeEmoji: '🗣️',
  },
]

export const conversations: Conversation[] = [
  {
    id: 'conv1',
    participants: ['me', 'p1'],
    unreadCount: 2,
    lastMessage: {
      id: 'm1',
      senderId: 'p1',
      receiverId: 'me',
      content:
        'Klingt super! Lassen Sie uns das beim nächsten Heimspiel vertiefen.',
      timestamp: '10:42',
      read: false,
    },
  },
  {
    id: 'conv2',
    participants: ['me', 'p3'],
    unreadCount: 0,
    lastMessage: {
      id: 'm2',
      senderId: 'me',
      receiverId: 'p3',
      content: 'Danke für die Insights zur Cloud-Migration. Sehr hilfreich.',
      timestamp: 'Gestern',
      read: true,
    },
  },
  {
    id: 'conv3',
    participants: ['me', 'p4'],
    unreadCount: 0,
    lastMessage: {
      id: 'm3',
      senderId: 'p4',
      receiverId: 'me',
      content:
        'Wir suchen aktuell noch Partner für das neue Quartier. Hätten Sie Zeit für einen Call?',
      timestamp: 'Montag',
      read: true,
    },
  },
  {
    id: 'conv4',
    participants: ['me', 'p5'],
    unreadCount: 1,
    lastMessage: {
      id: 'm4',
      senderId: 'p5',
      receiverId: 'me',
      content: 'Die VIP-Tickets für das Leipzig-Spiel sind hinterlegt.',
      timestamp: 'Letzte Woche',
      read: false,
    },
  },
]

// Network growth data per tenant (monthly: members, companies, events)
export const networkGrowthData: Record<
  string,
  { month: string; mitglieder: number; unternehmen: number; events: number }[]
> = {
  t1: [
    { month: 'Jan', mitglieder: 45, unternehmen: 12, events: 2 },
    { month: 'Feb', mitglieder: 78, unternehmen: 19, events: 3 },
    { month: 'Mär', mitglieder: 112, unternehmen: 28, events: 4 },
    { month: 'Apr', mitglieder: 156, unternehmen: 38, events: 3 },
    { month: 'Mai', mitglieder: 189, unternehmen: 45, events: 5 },
    { month: 'Jun', mitglieder: 218, unternehmen: 54, events: 4 },
    { month: 'Jul', mitglieder: 256, unternehmen: 63, events: 3 },
    { month: 'Aug', mitglieder: 278, unternehmen: 71, events: 6 },
    { month: 'Sep', mitglieder: 305, unternehmen: 78, events: 5 },
    { month: 'Okt', mitglieder: 318, unternehmen: 82, events: 4 },
    { month: 'Nov', mitglieder: 330, unternehmen: 86, events: 3 },
    { month: 'Dez', mitglieder: 342, unternehmen: 89, events: 7 },
  ],
  t2: [
    { month: 'Jan', mitglieder: 38, unternehmen: 10, events: 1 },
    { month: 'Feb', mitglieder: 65, unternehmen: 16, events: 2 },
    { month: 'Mär', mitglieder: 95, unternehmen: 24, events: 3 },
    { month: 'Apr', mitglieder: 128, unternehmen: 32, events: 2 },
    { month: 'Mai', mitglieder: 158, unternehmen: 40, events: 4 },
    { month: 'Jun', mitglieder: 185, unternehmen: 48, events: 3 },
    { month: 'Jul', mitglieder: 210, unternehmen: 55, events: 2 },
    { month: 'Aug', mitglieder: 232, unternehmen: 60, events: 5 },
    { month: 'Sep', mitglieder: 250, unternehmen: 65, events: 3 },
    { month: 'Okt', mitglieder: 265, unternehmen: 69, events: 4 },
    { month: 'Nov', mitglieder: 278, unternehmen: 73, events: 2 },
    { month: 'Dez', mitglieder: 287, unternehmen: 76, events: 6 },
  ],
  t3: [
    { month: 'Jan', mitglieder: 22, unternehmen: 6, events: 1 },
    { month: 'Feb', mitglieder: 40, unternehmen: 11, events: 2 },
    { month: 'Mär', mitglieder: 62, unternehmen: 17, events: 2 },
    { month: 'Apr', mitglieder: 85, unternehmen: 22, events: 3 },
    { month: 'Mai', mitglieder: 105, unternehmen: 28, events: 2 },
    { month: 'Jun', mitglieder: 125, unternehmen: 33, events: 3 },
    { month: 'Jul', mitglieder: 142, unternehmen: 38, events: 2 },
    { month: 'Aug', mitglieder: 158, unternehmen: 42, events: 4 },
    { month: 'Sep', mitglieder: 170, unternehmen: 46, events: 3 },
    { month: 'Okt', mitglieder: 180, unternehmen: 49, events: 2 },
    { month: 'Nov', mitglieder: 190, unternehmen: 52, events: 3 },
    { month: 'Dez', mitglieder: 198, unternehmen: 54, events: 5 },
  ],
  t4: [
    { month: 'Jan', mitglieder: 30, unternehmen: 8, events: 1 },
    { month: 'Feb', mitglieder: 55, unternehmen: 14, events: 2 },
    { month: 'Mär', mitglieder: 82, unternehmen: 21, events: 3 },
    { month: 'Apr', mitglieder: 108, unternehmen: 28, events: 2 },
    { month: 'Mai', mitglieder: 132, unternehmen: 35, events: 4 },
    { month: 'Jun', mitglieder: 155, unternehmen: 42, events: 3 },
    { month: 'Jul', mitglieder: 175, unternehmen: 48, events: 3 },
    { month: 'Aug', mitglieder: 192, unternehmen: 53, events: 5 },
    { month: 'Sep', mitglieder: 205, unternehmen: 57, events: 4 },
    { month: 'Okt', mitglieder: 215, unternehmen: 61, events: 3 },
    { month: 'Nov', mitglieder: 224, unternehmen: 64, events: 3 },
    { month: 'Dez', mitglieder: 231, unternehmen: 67, events: 6 },
  ],
  t5: [
    { month: 'Jan', mitglieder: 18, unternehmen: 5, events: 1 },
    { month: 'Feb', mitglieder: 32, unternehmen: 9, events: 1 },
    { month: 'Mär', mitglieder: 50, unternehmen: 14, events: 2 },
    { month: 'Apr', mitglieder: 68, unternehmen: 18, events: 2 },
    { month: 'Mai', mitglieder: 85, unternehmen: 23, events: 3 },
    { month: 'Jun', mitglieder: 102, unternehmen: 28, events: 2 },
    { month: 'Jul', mitglieder: 118, unternehmen: 32, events: 2 },
    { month: 'Aug', mitglieder: 132, unternehmen: 36, events: 3 },
    { month: 'Sep', mitglieder: 145, unternehmen: 39, events: 2 },
    { month: 'Okt', mitglieder: 155, unternehmen: 42, events: 3 },
    { month: 'Nov', mitglieder: 166, unternehmen: 45, events: 2 },
    { month: 'Dez', mitglieder: 176, unternehmen: 48, events: 4 },
  ],
  t6: [
    { month: 'Jan', mitglieder: 12, unternehmen: 4, events: 1 },
    { month: 'Feb', mitglieder: 22, unternehmen: 7, events: 1 },
    { month: 'Mär', mitglieder: 35, unternehmen: 10, events: 2 },
    { month: 'Apr', mitglieder: 48, unternehmen: 14, events: 1 },
    { month: 'Mai', mitglieder: 60, unternehmen: 17, events: 2 },
    { month: 'Jun', mitglieder: 72, unternehmen: 20, events: 2 },
    { month: 'Jul', mitglieder: 82, unternehmen: 23, events: 1 },
    { month: 'Aug', mitglieder: 92, unternehmen: 26, events: 3 },
    { month: 'Sep', mitglieder: 100, unternehmen: 28, events: 2 },
    { month: 'Okt', mitglieder: 108, unternehmen: 30, events: 2 },
    { month: 'Nov', mitglieder: 116, unternehmen: 33, events: 2 },
    { month: 'Dez', mitglieder: 124, unternehmen: 35, events: 3 },
  ],
}

export const messages: Record<string, Message[]> = {
  // conv1: Thomas Müller – Automotive
  conv1: [
    {
      id: 'm1-1',
      senderId: 'me',
      receiverId: 'p1',
      content:
        'Hallo Herr Müller, spannender Beitrag zum Thema E-Mobilität gestern!',
      timestamp: '10:30',
      read: true,
    },
    {
      id: 'm1-2',
      senderId: 'me',
      receiverId: 'p1',
      content: 'Wir arbeiten an einer ähnlichen Lösung für Ladeinfrastruktur.',
      timestamp: '10:31',
      read: true,
    },
    {
      id: 'm1-3',
      senderId: 'p1',
      receiverId: 'me',
      content:
        'Danke! Ja, das Thema Ladeinfrastruktur ist für uns gerade riesig. Wir planen bis Q3 ein eigenes Schnellladenetz an unseren Standorten.',
      timestamp: '10:42',
      read: true,
    },
    {
      id: 'm1-4',
      senderId: 'me',
      receiverId: 'p1',
      content: 'Das klingt ambitioniert. Wie viele Ladepunkte sind geplant?',
      timestamp: '10:45',
      read: true,
    },
    {
      id: 'm1-5',
      senderId: 'p1',
      receiverId: 'me',
      content:
        'Erstmal 120 Stück an 15 Standorten in Bayern. Wir haben gerade den Rahmenvertrag mit einem Energieversorger unterschrieben.',
      timestamp: '10:48',
      read: true,
    },
    {
      id: 'm1-6',
      senderId: 'p1',
      receiverId: 'me',
      content:
        'Übrigens: Wir stellen auf der IAA im September unseren neuen Elektro-Transporter vor. Hätten Sie Interesse an VIP-Tickets?',
      timestamp: '10:49',
      read: true,
    },
    {
      id: 'm1-7',
      senderId: 'me',
      receiverId: 'p1',
      content:
        'Auf jeden Fall! Das wäre großartig. Können wir uns vorher beim Business Lunch nächste Woche dazu austauschen?',
      timestamp: '10:52',
      read: true,
    },
    {
      id: 'm1-8',
      senderId: 'p1',
      receiverId: 'me',
      content:
        'Perfekt, ich bin beim Business Lunch am Dienstag dabei. Lassen Sie uns einen Tisch reservieren.',
      timestamp: '10:55',
      read: true,
    },
    {
      id: 'm1-9',
      senderId: 'p1',
      receiverId: 'me',
      content:
        'Klingt super! Lassen Sie uns das beim nächsten Heimspiel vertiefen. 🚗⚡',
      timestamp: '10:58',
      read: false,
    },
  ],
  // conv2: Michael Hoffmann – Tech
  conv2: [
    {
      id: 'm2-1',
      senderId: 'p3',
      receiverId: 'me',
      content:
        'Hallo! Ich wollte mich nochmal wegen der Cloud-Migration melden. Wir haben jetzt ein neues Framework dafür entwickelt.',
      timestamp: 'Gestern 09:15',
      read: true,
    },
    {
      id: 'm2-2',
      senderId: 'me',
      receiverId: 'p3',
      content:
        'Hey Michael, das klingt spannend! Wie unterscheidet sich euer Ansatz von den üblichen Terraform-Setups?',
      timestamp: 'Gestern 09:22',
      read: true,
    },
    {
      id: 'm2-3',
      senderId: 'p3',
      receiverId: 'me',
      content:
        'Wir setzen auf eine KI-gestützte Analyse der bestehenden Infrastruktur. Das Tool erkennt automatisch Abhängigkeiten und schlägt die optimale Migrationsstrategie vor.',
      timestamp: 'Gestern 09:28',
      read: true,
    },
    {
      id: 'm2-4',
      senderId: 'p3',
      receiverId: 'me',
      content:
        'Damit konnten wir die Migrationszeit bei einem Kunden um 60% reduzieren. Von 8 Monaten auf 3.',
      timestamp: 'Gestern 09:29',
      read: true,
    },
    {
      id: 'm2-5',
      senderId: 'me',
      receiverId: 'p3',
      content:
        'Beeindruckend! Wir haben aktuell genau das Problem – Legacy-Systeme, die wir in die Cloud bringen müssen, aber die Komplexität ist enorm.',
      timestamp: 'Gestern 09:35',
      read: true,
    },
    {
      id: 'm2-6',
      senderId: 'p3',
      receiverId: 'me',
      content:
        'Genau dafür ist es gedacht. Ich könnte euch eine Demo organisieren – vielleicht beim nächsten Netzwerk-Abend? Dann zeige ich es live.',
      timestamp: 'Gestern 09:40',
      read: true,
    },
    {
      id: 'm2-7',
      senderId: 'me',
      receiverId: 'p3',
      content:
        'Super Idee. Ich bringe unseren CTO mit, der ist gerade für die technische Roadmap verantwortlich.',
      timestamp: 'Gestern 09:45',
      read: true,
    },
    {
      id: 'm2-8',
      senderId: 'me',
      receiverId: 'p3',
      content: 'Danke für die Insights zur Cloud-Migration. Sehr hilfreich. 🚀',
      timestamp: 'Gestern 09:50',
      read: true,
    },
  ],
  // conv3: Julia Weber – Immobilien
  conv3: [
    {
      id: 'm3-1',
      senderId: 'me',
      receiverId: 'p4',
      content:
        'Hallo Frau Weber, ich habe Ihren Vortrag zur nachhaltigen Quartiersentwicklung beim letzten Event gesehen. Sehr inspirierend!',
      timestamp: 'Montag 14:00',
      read: true,
    },
    {
      id: 'm3-2',
      senderId: 'p4',
      receiverId: 'me',
      content:
        'Vielen Dank! Das Thema liegt mir sehr am Herzen. Wir planen gerade ein neues Quartier in München-Freiham mit 400 Wohneinheiten.',
      timestamp: 'Montag 14:12',
      read: true,
    },
    {
      id: 'm3-3',
      senderId: 'me',
      receiverId: 'p4',
      content:
        'Freiham ist ein spannendes Gebiet. Wie sieht das Nachhaltigkeitskonzept konkret aus?',
      timestamp: 'Montag 14:18',
      read: true,
    },
    {
      id: 'm3-4',
      senderId: 'p4',
      receiverId: 'me',
      content:
        'Komplett CO2-neutral im Betrieb. Photovoltaik auf allen Dächern, Geothermie für die Wärmeversorgung, und ein eigenes Mobilitätskonzept mit E-Carsharing.',
      timestamp: 'Montag 14:25',
      read: true,
    },
    {
      id: 'm3-5',
      senderId: 'p4',
      receiverId: 'me',
      content:
        'Dazu kommt ein Gewerbemix im Erdgeschoss – Coworking, Gastronomie, Nahversorgung. Alles fußläufig erreichbar.',
      timestamp: 'Montag 14:26',
      read: true,
    },
    {
      id: 'm3-6',
      senderId: 'me',
      receiverId: 'p4',
      content:
        'Das klingt nach einem Vorzeigeprojekt. Gibt es schon Partner für den Gewerbebereich?',
      timestamp: 'Montag 14:32',
      read: true,
    },
    {
      id: 'm3-7',
      senderId: 'p4',
      receiverId: 'me',
      content:
        'Wir suchen aktuell noch Partner für das neue Quartier. Hätten Sie Zeit für einen Call nächste Woche? Ich schicke Ihnen gerne die Projektunterlagen vorab.',
      timestamp: 'Montag 14:38',
      read: true,
    },
    {
      id: 'm3-8',
      senderId: 'me',
      receiverId: 'p4',
      content:
        'Sehr gerne! Donnerstag Nachmittag würde bei mir passen. Ich bin gespannt auf die Details. 🏗️',
      timestamp: 'Montag 14:42',
      read: true,
    },
  ],
  // conv4: Andreas Schmidt – Gastro
  conv4: [
    {
      id: 'm4-1',
      senderId: 'p5',
      receiverId: 'me',
      content:
        'Hallo! Kurze Info: Wir haben das Catering-Konzept für die VIP-Lounge komplett überarbeitet.',
      timestamp: 'Letzte Woche Mo',
      read: true,
    },
    {
      id: 'm4-2',
      senderId: 'me',
      receiverId: 'p5',
      content: 'Hey Andreas, das klingt gut! Was hat sich geändert?',
      timestamp: 'Letzte Woche Mo',
      read: true,
    },
    {
      id: 'm4-3',
      senderId: 'p5',
      receiverId: 'me',
      content:
        'Wir setzen jetzt auf ein Live-Cooking-Konzept mit regionalen Zutaten. Bayerische Küche neu interpretiert – vom Wagyu-Burger bis zum Trüffel-Knödel.',
      timestamp: 'Letzte Woche Mo',
      read: true,
    },
    {
      id: 'm4-4',
      senderId: 'p5',
      receiverId: 'me',
      content:
        'Dazu eine eigene Craft-Beer-Bar mit Sorten aus Münchner Mikrobrauereien. Kommt bei den Sponsoren super an.',
      timestamp: 'Letzte Woche Mo',
      read: true,
    },
    {
      id: 'm4-5',
      senderId: 'me',
      receiverId: 'p5',
      content:
        'Klingt fantastisch! Habt ihr auch vegetarische/vegane Optionen im Programm? Das wird immer häufiger nachgefragt.',
      timestamp: 'Letzte Woche Di',
      read: true,
    },
    {
      id: 'm4-6',
      senderId: 'p5',
      receiverId: 'me',
      content:
        'Absolut! 40% unserer neuen Karte ist plant-based. Wir haben einen eigenen veganen Koch eingestellt. Die Rote-Bete-Tatar-Variation ist der Hit.',
      timestamp: 'Letzte Woche Di',
      read: true,
    },
    {
      id: 'm4-7',
      senderId: 'me',
      receiverId: 'p5',
      content:
        'Top! Können wir für das nächste Heimspiel gegen Dortmund eine Sonderkarte zusammenstellen? Wir erwarten 30 VIP-Gäste.',
      timestamp: 'Letzte Woche Mi',
      read: true,
    },
    {
      id: 'm4-8',
      senderId: 'p5',
      receiverId: 'me',
      content:
        'Klar, ich stelle ein Menüvorschlag zusammen und schicke ihn bis Freitag. Soll ich auch die Weinbegleitung mit einplanen?',
      timestamp: 'Letzte Woche Mi',
      read: true,
    },
    {
      id: 'm4-9',
      senderId: 'me',
      receiverId: 'p5',
      content:
        'Ja bitte, das wäre perfekt. Vielleicht auch eine alkoholfreie Alternative.',
      timestamp: 'Letzte Woche Do',
      read: true,
    },
    {
      id: 'm4-10',
      senderId: 'p5',
      receiverId: 'me',
      content:
        'Die VIP-Tickets für das Leipzig-Spiel sind hinterlegt. Und das Menü schicke ich morgen rüber! 🍽️🍷',
      timestamp: 'Letzte Woche Fr',
      read: false,
    },
  ],
}
